module.exports = "https://static.wmbcdn.com/uniweb/images/032b1ab479184ae5ec440f81cad4d169.svg";